// extracted by css-extract-rspack-plugin
export default {"container":"dyO2bYIi_Qb7QJ24"};